import apiClient from "../lib/api/client";

export interface StartPipelineBody {
  simulation_id: number;
  steps: string[];
}

export interface StepDetail {
  duration: number;
  exit_code: number;
  executed_at: string;
}

export interface PipelineExecutionStatus {
  id: number;
  simulation_id: number;
  simulation_name: string;
  status: string;
  current_step: string | null;
  current_step_index: number;
  total_steps: number;
  progress_percentage: number;
  pipeline_steps: string[];
  steps_completed: string[];
  steps_failed: string[];
  step_details: Record<string, StepDetail>;
  error_message: string | null;
  started_at: string | null;
  completed_at: string | null;
  duration: number | null;
}

function unwrapPayload(raw: unknown): Record<string, unknown> {
  if (!raw || typeof raw !== "object") return {};
  const r = raw as Record<string, unknown>;
  const inner = r.data;
  if (inner && typeof inner === "object" && !Array.isArray(inner)) {
    return inner as Record<string, unknown>;
  }
  return r;
}

export const pipelineService = {
  async start(body: StartPipelineBody): Promise<number> {
    const response = await apiClient.post<unknown>("/pipeline/start", body);
    const payload = unwrapPayload(response);
    const id = Number(
      payload.execution_id ?? payload.executionId ?? payload.id,
    );
    if (!Number.isFinite(id)) {
      throw new Error("Resposta inválida: execution_id ausente");
    }
    return id;
  },

  async getStatus(executionId: number): Promise<PipelineExecutionStatus> {
    const response = await apiClient.get<unknown>(
      `/pipeline/status/${executionId}`,
    );
    const payload = unwrapPayload(response);
    return payload as unknown as PipelineExecutionStatus;
  },
};

export default pipelineService;
